// extracted by mini-css-extract-plugin
export default {"superHead":"SuperTyping_superHead__MhzPO","superpower":"SuperTyping_superpower__l2+XM","blinkingCursor":"SuperTyping_blinkingCursor__SvZBx","blink":"SuperTyping_blink__n4iNm"};